import * as React from "react"
const MonitoringActiveIcon = () => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        xmlSpace="preserve"
        stroke="#000"
        viewBox="0 0 412.998 412.998"
        width={17}
        height={17}
    >
        <defs>
            <linearGradient
                id='linear-gradient'
                x1='0.5'
                x2='0.5'
                y2='1'
                gradientUnits='objectBoundingBox'
            >
                <stop offset='0' stopColor='#f26930' />
                <stop offset='1' stopColor='#fba91a' />
            </linearGradient>
        </defs>

        {/* FILLED SCREEN RECTANGLE */}
        <rect
            x="30"
            y="40"
            width="352.998"
            height="214"
            fill="url(#linear-gradient)"
        />

        {/* MONITOR FRAME */}
        <path fill="url(#linear-gradient)" stroke="#000" d="M392.998 28.339H20c-11.046 0-20 8.954-20 20v234c0 11.046 8.954 20 20 20h139.499v45.32h-54.283c-10.201 0-18.5 8.299-18.5 18.5s8.299 18.5 18.5 18.5h202.566c10.201 0 18.5-8.299 18.5-18.5s-8.299-18.5-18.5-18.5h-54.283v-45.32h139.499c11.046 0 20-8.954 20-20v-234c0-11.046-8.954-20-20-20zm-10 244H30v-214h352.998v214z" />

        {/* BARS INSIDE */}
        <path fill='white' strokeWidth='1' d="M134.589 235.304c7.563 0 13.701-6.136 13.701-13.699v-65.156c0-7.564-6.139-13.697-13.701-13.697-7.564 0-13.695 6.133-13.695 13.697v65.155c0 7.564 6.13 13.7 13.695 13.7zM182.53 235.304c7.564 0 13.695-6.136 13.695-13.699V108.506c0-7.564-6.131-13.695-13.695-13.695-7.566 0-13.699 6.131-13.699 13.695v113.099c0 7.563 6.133 13.699 13.699 13.699zM230.468 235.304c7.566 0 13.699-6.136 13.699-13.699v-84.333c0-7.564-6.133-13.695-13.699-13.695-7.562 0-13.693 6.131-13.693 13.695v84.333c-.004 7.563 6.127 13.699 13.693 13.699zM278.411 235.304c7.562 0 13.692-6.136 13.692-13.699v-98.714c0-7.564-6.132-13.697-13.692-13.697-7.564 0-13.701 6.133-13.701 13.697v98.714c0 7.563 6.137 13.699 13.701 13.699z" />
    </svg>
)
export default MonitoringActiveIcon
